import React from 'react';
import { Layout, Button } from 'antd';
import { MenuOutlined } from '@ant-design/icons';

const { Header: AppHeader } = Layout

type HeaderProps = {
  onSubmit?: () => void
  buttonTitle?: string
  disabled?: boolean
}

const Header : React.FC<HeaderProps> = ({ onSubmit, buttonTitle = "Submit", disabled = false }) => {
  return (
    <AppHeader className="flex justify-between items-center bg-white shadow-md px-6">
      <div className="text-lg font-semibold">
        <img src="/logo_meru.svg" alt="Logo" className="h-8" />
      </div>
      {onSubmit ?
        <Button
          type="primary"
          size="large"
          disabled={disabled}
          onClick={onSubmit}
        >{buttonTitle}</Button> :
        <Button
          type="text"
          icon={<MenuOutlined className="text-xl" />}
          className="hover:bg-gray-100"
        />
      }
    </AppHeader>
  );
};

export default Header;